import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography, Grid, Paper, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import logo from '../images/zodiak23.png'; // Import logo

// Styled components
const PaperStyled = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: 400,
  margin: 'auto',
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[6],
}));

const ButtonStyled = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1.5),
}));

const Copyright = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
}));

const Logo = styled('img')({
  width: '380px', // Set the logo width
  height: 'auto',
  marginBottom: '16px', // Space between logo and form
});

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://localhost:8080/zodiakid_backend/api/register.php', {
        username,
        email,  // Include email in the request
        password
      });
      console.log('Response:', response.data); // Log the response data
      const result = response.data;
      if (result.status === 'success') {
        setMessage('Registration successful');
      } else {
        setMessage(result.message);
      }
    } catch (error) {
      console.error('Error:', error); // Log the error
      setMessage('Registration failed');
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh', background: '#f5f5f5' }}>
      <PaperStyled>
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Logo src={logo} alt="Zodiak Logo" /> {/* Display logo instead of text */}
          <form onSubmit={handleRegister}>
            <TextField
              label="Username"
              fullWidth
              margin="normal"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
            />
            <ButtonStyled type="submit" variant="contained" color="primary" fullWidth>
              Register
            </ButtonStyled>
          </form>
          {message && <Typography color="error" align="center" sx={{ mt: 2 }}>{message}</Typography>}
          <Divider sx={{ my: 2 }} />
          <Typography variant="body2" align="center">
            Already have an account? <Link to="/login" style={{ textDecoration: 'none', color: '#1976d2' }}>Login</Link>
          </Typography>
        </Grid>
        <Copyright>
          &copy; {new Date().getFullYear()} ZodiakID. All rights reserved.
        </Copyright>
      </PaperStyled>
    </Grid>
  );
}

export default Register;
